// extracted by mini-css-extract-plugin
export default {"cardEventMain":"v2Z5NEwB","type0":"DtqiJsyf","ad-site-wrapper-small":"ad-site-wrapper-small","announce":"UqwPRZkB","image":"GEHl_g9i","mobile":"vs1193b3","time":"NMS1FLLZ"};